import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import { Focusable } from "@xo-union/ui-accessibility";
import defaultIconSet from "../../icon-sets/v2/index.js";
import styles from "../../css/interactive-icon.css";
import Icon from "../Icon/index.js";
const InteractiveIcon = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    name,
    className,
    iconSet,
    size,
    as: Type,
    block,
    'aria-label': ariaLabel,
    ...props
  } = _ref;
  const classes = [className, styles.container, block ? styles['is-block'] : styles['is-inline'], size ? styles[`size-${size}`] : ''];
  return /*#__PURE__*/React.createElement(Focusable, _extends({
    ref: ref,
    as: Type,
    className: classes.join(' ')
  }, ariaLabel && {
    'aria-label': ariaLabel
  }, props), /*#__PURE__*/React.createElement(Icon, _extends({
    name: name,
    iconSet: iconSet,
    size: size
  }, ariaLabel && {
    'aria-hidden': true
  })));
});
process.env.NODE_ENV !== "production" ? InteractiveIcon.propTypes = {
  /**
   * Name of the icon to render in the anchor tag
   */
  name: PropTypes.string.isRequired,
  /**
   * Component to wrap Icon with; or string to represent valid html tag (e.g. 'a')
   */
  as: PropTypes.elementType,
  /**
   * Whether to render interactive container as a block element.
   */
  block: PropTypes.bool,
  /**
   * Class names for styling the component
   */
  className: PropTypes.string,
  /**
   * The icon set to use
   */
  iconSet: PropTypes.shape({
    resolve: PropTypes.func.isRequired
  }),
  /**
   * A size class. See the size table for more info.
   */
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  /**
   * Accessible short description. If provided, the icon will be hidden from the accessibility tree.
   */
  'aria-label': PropTypes.string
} : void 0;
InteractiveIcon.defaultProps = {
  className: '',
  block: false,
  iconSet: defaultIconSet,
  size: null,
  'aria-label': null
};
InteractiveIcon.displayName = 'InteractiveIcon';
export default InteractiveIcon;